import {Button, ModalBody, ModalContent, ModalFooter} from "@nextui-org/react";
import Lottie from "lottie-react";
import close_door from "../../assets/close_door.json";
import React from "react";

export const CloseDoor = ({Reseting}) => {
    return (

        <ModalContent>

            <ModalBody>
                <div className="container">
                    <Lottie animationData={close_door} loop={true} speed={2}/>
                <p className="text-2xl text-center">¡Favor cerrar las compuertas una vez retirado el producto!</p>
                </div>
            </ModalBody>
            <ModalFooter className="flex justify-center gap-1" >

                <Button size="lg" color="success" variant="solid" onPress={() => {
                    Reseting();
                }}>
                    Aceptar
                </Button>
            </ModalFooter>
        </ModalContent>


    )
}